export default __webpack_public_path__ + "static/mobile_KV01-826b208320d0541444832d529fc87e26.mp4";